import { useCallback } from "react"

const AUTH_STATE_KEY = "auth_state"
const STATE_EXPIRY_KEY = "auth_state_expiry"

function useAuthState() {
    const verifyState = useCallback((returnedState: string | null): boolean => {
        if (!returnedState) return false

        const savedState = sessionStorage.getItem(AUTH_STATE_KEY)
        const expiryTime = parseInt(sessionStorage.getItem(STATE_EXPIRY_KEY) ?? "0")

        sessionStorage.removeItem(AUTH_STATE_KEY)
        sessionStorage.removeItem(STATE_EXPIRY_KEY)

        return savedState === returnedState && Date.now() < expiryTime
    }, [])

    const clearState = useCallback(() => {
        sessionStorage.removeItem(AUTH_STATE_KEY)
        sessionStorage.removeItem(STATE_EXPIRY_KEY)
    }, [])

    return { verifyState, clearState }
}

export default useAuthState
